import "angular";
import accountService from "../accountServiceModule/AccountService";

import DynamicElectionRoutes from "./DynamicElectionRoutes";
import DynamicElectionRoutingController from "./DynamicElectionRoutingController";
import DynamicElectionRoutingService from "./DynamicElectionRoutingService";

const moduleName = "DynamicElectionRoutingModule";

const DynamicElectionRoutingModule = angular
    .module(moduleName, [])
    .controller("DynamicElectionRoutingController", DynamicElectionRoutingController)
    .config(DynamicElectionRoutes)
    .service("DynamicElectionRoutingService", DynamicElectionRoutingService)
    .service("AccountService", accountService);

export default DynamicElectionRoutingModule;
